/**
 *  Loading.jsx
 *  Security Care
 *
 *  Last update by Bruno Bandeira on 19/02/2019.
 *  Contact: bruno@avamobile.com.br
 *
 *  Copyright © 2018 AVA Soft Solutions. All rights reserved.
 */

// system
import React, { Component } from "react";

// components
import Loader from 'react-loader-spinner';

// style
import "./style.css";

class Loading extends Component {

    render() {
        return (
            <div className="loader">
                <div className="loader-center">
                    <Loader 
                        type="Oval"
                        color="#00BFFF"
                        height="100"	
                        width="100"
                    /> 
                </div>
          </div>
        );
    }
}

export default Loading;


// WEBPACK FOOTER //
// ./src/views/Loader/Loader.jsx